import { render, staticRenderFns } from "./SectionSpace.vue?vue&type=template&id=59018eb5&"
import script from "./SectionSpace.vue?vue&type=script&lang=js&"
export * from "./SectionSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports